import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import * as moment from 'moment';
import 'moment-timezone';

// Patch Africa/Casablanca with IANA tzdata 2026c: Morocco switches
// permanently to UTC+0 on 2026-09-20 at 02:00 local (01:00 UTC).
// moment-timezone bundles IANA 2025b which doesn't have this transition.
// Guard: skip if moment-timezone already has correct data (offset=0 after Sep 20).
(function patchCasablancaZone() {
  const tz = (moment as any).tz;
  const zone = tz && tz.zone('Africa/Casablanca');
  if (!zone) return;
  const oct2026 = 1790992800000; // 2026-10-01T10:00:00Z — a date after the transition
  const idx = zone.untils.findIndex(function(u) { return u > oct2026; });
  if (idx < 0 || zone.offsets[idx] === 0) return; // already correct
  const transitionMs = 1789866000000; // 2026-09-20T01:00:00Z
  let i = 0;
  while (i < zone.untils.length && zone.untils[i] <= transitionMs) i++;
  zone.untils.splice(i, zone.untils.length - i, transitionMs, Infinity);
  zone.offsets.splice(i, zone.offsets.length - i, -60, 0);
  zone.abbrs.splice(i, zone.abbrs.length - i, '+01', '+00');
})();
import { IDatePickerConfig } from 'ng2-date-picker';

import { AppConfig } from './../../Common/appConfiguration';
import { AppMessage } from './../../Common/appMessage';
import { GaService } from './../../Common/ng2-date-picker/ga.service';
import { AppGlobals } from './../../Common/Services/app.global';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../dialog-confirm-component/dialog-confirm-component.component';
import { ManageChildHeadersService } from '././../../Common/Services/manage-child-headers.service';
import { Profile, PatchProfile, ScheduleExamDateService } from './schedule-exam-date.service';
import { FeatureFlagService, ToggleName } from '../../Common/Services/feature-flag.service';
import { userRole_globalAdmin } from "./../../Common/appConstant";

@Component({
  selector: 'app-schedule-exam-date',
  templateUrl: './schedule-exam-date.component.html',
  styleUrls: ['./schedule-exam-date.component.css'],
  providers: [ScheduleExamDateService]
})
export class ScheduleExamDateComponent implements OnInit {
  scheduleForm: FormGroup;
  selectedExamModel: any = {};
  selectedExamLocationModel: any = {};
  examDateModel: any = {};
  minDate: Date;
  maxDate: Date;
  bypassFilters: Set<string>;
  isGlobalAdmin: boolean;
  calConfig: IDatePickerConfig;
  hideConflictTypes = ["locHoursOfOperation", "uniHoursOfOperation", "expired"];
  public my_Class = 'inactive';
  public animatedClass: any;
  public updateProfileBody: PatchProfile | null;
  timezoneId: string;
  locationId: number | null;
  timeZone: string;
  koalaId: number | null;

  constructor(
    public _utility: Utility,
    private _router: Router,
    private _scheduleExamDateService: ScheduleExamDateService,
    public _dialog: MdDialog,
    private _vcr: ViewContainerRef,
    private gaService: GaService,
    private _manageChildHeadersService: ManageChildHeadersService,
    private _appMessage: AppMessage,
    public _appConfig: AppConfig,
    private _appGlobals: AppGlobals,
  ) {

    this.scheduleForm = new FormGroup({
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern(AppConfig.phoneNumberRegEx)]),
      certificateId: new FormControl('', Validators.pattern(AppConfig.certificateIDRegEx))
    });

    // set global admin flag
    let role = this._appGlobals.userInfo.getValue().userRole;
    role = role && role.toUpperCase()
    this.isGlobalAdmin = role == userRole_globalAdmin;
  }

  ngOnInit() {
    if (!this._appGlobals.selectedExamModel || (!this._appGlobals.selectedExamLocationModel && !this._utility.usesVirtualLocation(this._appGlobals.selectedExamModel))) {
      this._router.navigate([(this._utility.leftMenusList_CUser && this._utility.leftMenusList_CUser.landingUrl) ? this._utility.leftMenusList_CUser.landingUrl : '/**']);
      return;
    } else {
      this.selectedExamModel = this._appGlobals.selectedExamModel;
      if (!this._utility.usesVirtualLocation(this.selectedExamModel)) {
        this.selectedExamLocationModel = this._appGlobals.selectedExamLocationModel;
      }
      this.timezoneId = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.timeZoneId : this.selectedExamModel.virtualLocationTimeZone.id
      this.timeZone = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.timeZone : this.selectedExamModel.virtualLocationTimeZone.name
      this.locationId = (!this._utility.usesVirtualLocation(this.selectedExamModel)) ? this.selectedExamLocationModel.id : 0
      this.koalaId = (
        this.selectedExamModel.examType == "CE"
          ? this.selectedExamLocationModel.koalas[0].id
          : null
      );
      this._utility.setTxnStatus(true);
      this.animatedClass = false;
      this.examDateModel = {
        selectedCalDate: new Date(),
        timeSlotsByDate: [],
        selectedTimeSlot: { iso: null, date: null, time: null },
        showDiv: 2,
        tncChecked: false,
        submitInProcess: false
      };
      if (this._appGlobals.userId === 0) {
        this._scheduleExamDateService.getProfile().subscribe((profile: Profile) => {
          this.updateScheduleForm(profile);
        });
      }

      let cDate = new Date();
      this.minDate = new Date(cDate.getFullYear(), cDate.getMonth(), cDate.getDate());
      this.maxDate = this._utility.convertToDateTime(this.selectedExamModel.eligibilityExpirationDate);//this.selectedExamModel.expirationDate;
      this.bypassFilters = new Set(
        this._appGlobals.userPermissions.getValue().has("exam-sessions.bypass.filter.proctoring-capacity")
          ? ["proctoring-capacity"]
          : []
      );
      this.calConfig = {
        min: moment(this.minDate),
        max: moment(this.maxDate),
        firstDayOfWeek: 'su',
        monthFormat: 'MMM, YYYY',
        disableKeypress: true,
        allowMultiSelect: false,
        onOpenDelay: 0,
        weekDayFormat: 'dd',
        showNearMonthDays: false,
        showWeekNumbers: false,
        enableMonthSelector: true,
        yearFormat: 'YYYY',
        showGoToCurrent: true,
        dayBtnFormat: 'D',
        monthBtnFormat: 'MMM',
        hours12Format: 'hh',
        hours24Format: 'HH',
        meridiemFormat: 'A',
        minutesFormat: 'mm',
        minutesInterval: 1,
        secondsFormat: 'ss',
        secondsInterval: 1,
        showSeconds: false,
        showTwentyFourHours: false,
        timeSeparator: ':',
        multipleYearsNavigateBy: 1,
        showMultipleYearsNavigation: false,
        locale: 'en'
      };
      this.setTimeSlots();
    }
  }

  getVirtualLocationCountryId() {
    if (this.selectedExamModel.virtualLocationCountry) {
      return this.selectedExamModel.virtualLocationCountry.id;
    }

    return "";
  }

  getLocationCountryAlpha2Code() {
    const code = this.selectedExamModel.virtualLocationCountry.code;

    if (typeof code !== "string" || !/^[A-Z]{2}$/.test(code)) {
      throw new Error("Could not determine country alpha 2 code");
    }

    return code;
  }

  onCertIDFieldKeyup() {
    let field = this.scheduleForm.controls.certificateId;
    let formattedValue = this._utility.textFormat(field.value, 3, "-"); // format text with "-"
    field.setValue(formattedValue.substring(0, 30)); // substring(0, 30) -- this logic works if someone long press any key then only take start 30 inputs only
  }

  // to reserve the exam
  reserveExam() {
    if (this.scheduleForm.invalid) {
      return;
    }

    this.examDateModel.submitInProcess = true;

    const profilePatchBody: PatchProfile = {
      phone: this.scheduleForm.controls.phoneNumber.value,
    };
    const certificateId = this.scheduleForm.controls.certificateId.value;
    if (certificateId) {
      profilePatchBody.certificate = {
        id: certificateId,
      };
    }
    this._scheduleExamDateService.updateProfile(profilePatchBody)
      .switchMap((profile: Profile) => {
        this.updateScheduleForm(profile);
        const scheduleExamBody = {
          location: this.selectedExamModel.examType === "CE" ? {
            koala: { id: this.koalaId },
          } : {
              timezone: this.selectedExamModel.virtualLocationTimeZone.name,
              country: this.getLocationCountryAlpha2Code(),
            },
          eligibility: {
            code: this.selectedExamModel.eligibilityCode,
          },
          exam: {
            sku: this.selectedExamModel.examCode,
          },
          start: this.examDateModel.selectedTimeSlot.iso,
          bypass_filters: Array.from(this.bypassFilters),
        };
        return this._scheduleExamDateService.scheduleExam(this.selectedExamModel.examType, scheduleExamBody);
      })
      .subscribe(uuid => {
        this.examDateModel.submitInProcess = false;
        this._utility.onSuccessCallback({
          responseCode: "S0001",
          responseDescription: "Success",
          response: uuid,
        }, null, () => {
          this._appGlobals.selectedExamModel = null;
          this._appGlobals.selectedExamLocationModel = null;
          this._utility.clearTxnStatus();
          this._dialog.open(DialogConfirmComponentComponent, {
            data: {
              modelType: "SUCCESS",
              msgTitle: this._appMessage.getItem['Common013'],//'Congratulations',
              msg: this.selectedExamModel.isReschedule == true ? this._appMessage.getItem['UMsg00024'] : this._appMessage.getItem['UMsg00025'],//data.Response,
              showDefaultBtn: true,
              defaultBtnCaption: this._appMessage.getItem['Common011'],//'OK',
              redirectUrl: this._utility.isAdminAsCandidate() ? "/AdmManageEligibilities" : "/Dashboard"
            }
          });
        });
      }, error => {
        this._utility.removeLoaderCount();
        this.showErrorModal(error);
      });
  }

  /**
   * back to TimeList
   * this.examDateModel.tncChecked - used to handle checkbox corresponding to I Agree for terms and conditions
   * showDiv - ot hide/show div in html(1-show text,2-show slots,3-show scheduling,4-show Rescheduling)
   */
  backToTimeList() {
    this.examDateModel.tncChecked = false;
    this.examDateModel.showDiv = 2;
    this.my_Class = this.my_Class == "inactive" ? 'active animated' : 'inactive';
    this.setTimeSlots();
  }

  private updateScheduleForm(profile: Profile) {
    this.scheduleForm.setValue({
      phoneNumber: profile.phone || "",
      certificateId: profile.certificate.id || "",
    });
  }

  // date selected event of calendar
  dateSelected(event: any) {
    let date = new Date(event.date);
    this.examDateModel.selectedCalDate = date;
    this.examDateModel.showDiv = 2; // show slots div
    this.examDateModel.tncChecked = false;
    this.setTimeSlots();
  }

  // to get and set timeslots
  setTimeSlots() {
    this.examDateModel.timeSlotsByDate = [];
    this.examDateModel.selectedTimeSlot.iso = null;
    this.examDateModel.selectedTimeSlot.date = null;
    this.examDateModel.selectedTimeSlot.time = null;

    let selectedMonth = this.examDateModel.selectedCalDate.getMonth();
    let selectedDay = this.examDateModel.selectedCalDate.getDate();
    let selectedYear = this.examDateModel.selectedCalDate.getFullYear();
    let fromDateStr = selectedYear
      + "-" + ((selectedMonth + 1) >= 10 ? (selectedMonth + 1) : '0' + (selectedMonth + 1))
      + "-" + (selectedDay >= 10 ? selectedDay : '0' + selectedDay);

    this._utility.addLoaderCount();
    const start = moment(this.examDateModel.selectedCalDate);
    const end = start.clone().add(1, 'weeks');
    let urlParams = "?eligibility=" + this.selectedExamModel.eligibilityCode;
    urlParams += "&sku=" + this.selectedExamModel.examCode;
    if (this.selectedExamModel.examType == "CE") {
      urlParams += "&koala=" + this.koalaId;
    }
    urlParams += "&start=" + start.toISOString();
    urlParams += "&end=" + end.toISOString();
    urlParams += "&duration=PT15M";
    if (this.isGlobalAdmin) {
      urlParams += Array.from(this.bypassFilters).map(bypass => `&bypass_filters=${bypass}`).join("");
    }
    this._scheduleExamDateService.getExamSlots(this.selectedExamModel.examType, urlParams)
      .subscribe(
      (possible_starts: string[]) => {
        this._utility.onSuccessCallback({
          responseCode: "S0001",
          responseDescription: "Success",
          response: possible_starts,
        },
          null,
          () => {
            let slotSetDate: any = null;
            let slotSetHour: any = null;
            const tz = this.timeZone;
            const dateToSlotMap = Array.from({ length: 7 })
                .map((_, index) => start.clone().add(index, 'days'))
                .map(value => (moment(value) as any).tz(tz).format('YYYY-MM-DD'))
                .reduce((accumulator, date) => {
                  accumulator[date] = this.createSlotSetDate(date);
                  return accumulator;
                }, {});
            Object.keys(dateToSlotMap)
                .map(key => dateToSlotMap[key])
                .forEach(value => this.examDateModel.timeSlotsByDate.push(value));
            possible_starts
              .map(possible_start => {
                const m = (moment(possible_start) as any).tz(tz);
                return {
                  iso: possible_start,
                  date: m.format('YYYY-MM-DD'),
                  time: m.format('HH:mm:ss'),
                  conflictTypes: [],
                }
              }).map(datetime => ({
                ...datetime,
                time: datetime.time.split(":").splice(0, 2).join(":"),
                hour: datetime.time.split(":").splice(0, 1)[0],
                isOpen: true,
                display: !datetime.conflictTypes || !this.hideConflictTypes.some(ct => datetime.conflictTypes.includes(ct)),
              })).forEach(ts => {
                slotSetDate = dateToSlotMap[ts.date];
                slotSetHour = slotSetDate.timeSlotsByHour.find(({hour}) => hour === ts.hour);
                if (slotSetHour === undefined) {
                    slotSetHour = this.createSlotSetHour(ts.hour);
                    slotSetDate.timeSlotsByHour.push(slotSetHour);
                }
                slotSetHour.timeSlots.push(ts);

                if (ts.display) slotSetHour.display = true;
                if (ts.isOpen) slotSetHour.hasOpenSlots = true;
                if (slotSetHour.hasOpenSlots) slotSetDate.hasOpenSlots = true;
              });
          });
      }, error => {
        this._utility.removeLoaderCount();
        this.showErrorModal(error);
      }, () => { });
  }

  createSlotSetDate(date) {
    return {
      date: new Date(date), timeSlotsByHour: [],
      dateStr: date, hasOpenSlots: null,
    };
  }

  createSlotSetHour(hour) {
    return {
      time: hour + ':00', hour: hour, timeSlots: [],
      hasOpenSlots: null, expanded: false, display: null,
    };
  }

  timeSlotIsOpen(timeSlot) {
    if (!timeSlot) return false;

    return !timeSlot.conflictTypes || (
      timeSlot.conflictTypes.length == 1 && this.isGlobalAdmin && timeSlot.conflictTypes[0] == "concurrent"
    );
  }

  toggleSlotSet(slotSet) {
    if (!slotSet.hasOpenSlots) return;
    slotSet.expanded = !slotSet.expanded;
  }

  // on selection of time, confirmation box is shown for status true
  selectTimeSlot(timeSlot) {
    if (!timeSlot.isOpen) return;

    // warn about scheduling a concurrent exam
    if (timeSlot.conflictTypes && timeSlot.conflictTypes.indexOf("concurrent") > -1) {
      let confirmDialogMsgModel = {
        modelType: "CONFIRMATION",
        msgTitle: this._appMessage.getItem['Common007'],//Are you sure?
        msg: this._appMessage.getItem["UMsg00079"],
        isConfirmBox: true,
        confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
        cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
      };

      this._dialog.open(DialogConfirmComponentComponent, {
        data: confirmDialogMsgModel
      }).afterClosed().subscribe(result => {
        if (result == "1") this.onSelectedTimeSlot(timeSlot);
      });
    } else {
      this.onSelectedTimeSlot(timeSlot);
    }
  }

  //On selection of time, proceed for confirmation screen
  onSelectedTimeSlot(timeSlot) {
    this.examDateModel.showDiv = this.selectedExamModel.isReschedule ? 4 : 3;
    this.examDateModel.selectedTimeSlot = timeSlot;
  }

  // to show the direction of exam centre in google map
  locateUs(lat, lng): void {
    window.opener = null;
    window.open("https://maps.google.com/?q=" + lat + "," + lng);
  }

  // Show error modal with detail message from API response
  private showErrorModal(error: any): void {
    let errorMessage = "An error occurred. Please try again.";

    // Extract detail message from error response
    if (error && error.error && error.error.detail) {
      errorMessage = error.error.detail;
    } else if (error && error.detail) {
      errorMessage = error.detail;
    }

    this._dialog.open(DialogConfirmComponentComponent, {
      data: {
        modelType: "ERROR",
        msgTitle: "Error",
        msg: errorMessage,
        showDefaultBtn: true,
        defaultBtnCaption: this._appMessage.getItem['Common011'] || 'OK'
      }
    }).afterClosed().subscribe(() => {
      this.goBackToPreviousRoute();
    });
  }

  // Navigate back to the appropriate route
  private goBackToPreviousRoute(): void {
    const redirectUrl = this._utility.isAdminAsCandidate() ? "/AdmManageEligibilities" : "/Dashboard";
    this._router.navigate([redirectUrl]);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-date/schedule-exam-date.component.ts